export const GET_REQUEST_OTHER_USER_RESULTS_START = "GET_REQUEST_OTHER_USER_RESULTS_START";
export const GET_REQUEST_OTHER_USER_RESULTS_SUCCESS = "GET_REQUEST_OTHER_USER_RESULTS_SUCCESS";
export const GET_REQUEST_OTHER_USER_RESULTS_ERROR = "GET_REQUEST_OTHER_USER_RESULTS_ERROR";